import React from "react";
import TabletLayout from "../../Shared/TabletLayout";
import TabletNotice from "../../Shared/TabletNotice";
import OriginalComponentImpl from "../../../Components/AIML/QuantAnalysisUpload";

const OriginalComponent = OriginalComponentImpl as unknown as React.ComponentType<any>;

interface Props {
  [key: string]: any;
}

const QuantAnalysisUploadTablet: React.FC<Props> = (props) => {
  return (
    <TabletLayout title="QuantAnalysisUpload">
      <TabletNotice page="QuantAnalysisUpload" />
      <OriginalComponent {...props} />
    </TabletLayout>
  );
};

export default QuantAnalysisUploadTablet;